import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useT } from '../lib/i18n.js';

// Where "Support" points on every screen (§ support). A mailbox that forwards
// to the operator — not a personal address.
const SUPPORT_EMAIL = 'support@fiestachallenges.com';

// A slim, route-aware bar pinned to the top of every functional screen.
// - A back button on the LEFT of every screen — some devices (kiosk browsers,
//   in-app webviews, older Androids) have no reliable back gesture, and guests
//   were getting stranded. It just calls history.back().
// - Guest screens (/app, /e/:code, /results/:id): a growth nudge inviting guests
//   to host their own event, plus the support link.
// - Host / auth / legal screens: the support link only.
// - The pre-launch splash ("/") and the projector Wall own the full screen, so
//   we stay out of their way. Same for the docs page, which carries the public
//   MarketingNav — stacking this bar on top would give it two headers.
export function AppChrome() {
  const t = useT();
  const nav = useNavigate();
  const { pathname } = useLocation();

  if (pathname === '/' || pathname === '/how-it-works' || pathname.startsWith('/wall/')) return null;

  const isGuest =
    pathname === '/app' || pathname.startsWith('/e/') || pathname.startsWith('/results/');

  return (
    <div className="pp-chrome">
      <div className="pp-chrome-left">
        <button className="pp-chrome-back" onClick={() => nav(-1)} aria-label={t('nav_back')}>
          ←
        </button>
        {isGuest && (
          <Link className="pp-chrome-pitch" to="/event_creation">
            <span>{t('growth_pitch')}</span>
            <strong>{t('growth_cta')}</strong>
          </Link>
        )}
      </div>
      <a className="pp-chrome-support" href={`mailto:${SUPPORT_EMAIL}`}>
        {t('support_contact')}
      </a>
    </div>
  );
}
